// extracted by mini-css-extract-plugin
export default {"borderInner":"style_borderInner__0pA-s","spin":"style_spin__Bmya6","borderOuter":"style_borderOuter__i8Wqv"};